// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__mSsY9","section-1":"About_section-1__pOhay","content":"About_content__PRCQV","section-2":"About_section-2__rQOku"};